import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import type React from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  highlighted: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
}));

interface HighlightedFragmentProps {
  fragment: string;
}

const HighlightedFragment: React.FC<HighlightedFragmentProps> = ({ fragment }) => {
  const classes = useStyles();

  // Split on <mark> and </mark> tags, capturing the tags as delimiters
  const parts = fragment.split(/(<mark>|<\/mark>)/);
  // Use a depth counter instead of a boolean to handle nested/overlapping marks safely
  let markDepth = 0;

  return (
    <span>
      {parts.map((part, i) => {
        if (part === '<mark>') {
          markDepth++;
          return null;
        }
        if (part === '</mark>') {
          markDepth = Math.max(0, markDepth - 1);
          return null;
        }
        return (
          // biome-ignore lint/suspicious/noArrayIndexKey: split parts have no stable id
          <span key={i} className={markDepth > 0 ? classes.highlighted : undefined}>
            {part}
          </span>
        );
      })}
    </span>
  );
};

export default HighlightedFragment;
